import React from "react"
import KEYBlue from "../common/keylist-blue"

const WearableappServices: React.FC = () => {
  return (
    <section className="Development-Services section-py bg-grey">
      <div className="container lg:container mx-auto">
        <div className="row grid lg:grid-cols-12 xl:grid-cols-12 md:grid-cols-12 gy-10">
          <div className="xl:col-span-6 lg:col-span-6 md:col-span-12">
            <div className="dev-service-inner">
              <h2 className="fw-700 fs-xl">
                We Hold Expertise in Crafting Feature-Rich Wearable Based Solution
              </h2>
            </div>
          </div>
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-6">
            <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
              <KEYBlue text="Custom Wearable App Development" />
              <KEYBlue text="iOS Wearable App Development" />
              <KEYBlue text="Smart Watch App Development" />
              <KEYBlue text="Fitness Tracking App Development" />
              <KEYBlue text="Wireless Payment Solutions" />

            </div>
          </div>
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-6">
            <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
              <KEYBlue text="Virtual Reality App Development" />
              <KEYBlue text="Wearable App UI/UX Development" />
              <KEYBlue text="Android Wearable App Development & Maintenance" />
              <KEYBlue text="Upgrading Existing Android/iOS App to Make It Compatible with Wearable Devices" />

            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default WearableappServices